import { render, staticRenderFns } from "./InspectionRoomsCompletionByArea.vue?vue&type=template&id=99861b56&"
import script from "./InspectionRoomsCompletionByArea.vue?vue&type=script&lang=js&"
export * from "./InspectionRoomsCompletionByArea.vue?vue&type=script&lang=js&"
import style0 from "./InspectionRoomsCompletionByArea.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports